import React from 'react';
import { CreditCard, Copy } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { toast } from '../../components/ui/sonner';

const RIBPage = ({ client }) => {
  const rib = client.rib || {
    iban: 'FR76 1234 5678 9012 3456 7890 123',
    bic: 'FTNOFRP1XXX',
    accountHolder: `${client.firstName} ${client.lastName}`,
    bankName: 'Fortuneo Banque'
  };

  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text.replace(/\s/g, ''));
    toast.success(`${label} copié dans le presse-papier`);
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Relevé d&apos;Identité Bancaire (RIB)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-lg p-6 text-white mb-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <p className="text-sm text-green-100">Titulaire</p>
                <p className="text-lg font-semibold">{rib.accountHolder}</p>
              </div>
              <CreditCard size={32} />
            </div>
            <div>
              <p className="text-sm text-green-100 mb-1">IBAN</p>
              <p className="font-mono text-lg tracking-wider">{rib.iban}</p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="border rounded-lg p-4">
              <div className="flex justify-between items-center">
                <div className="flex-1">
                  <p className="text-sm text-gray-500">Banque</p>
                  <p className="font-medium">{rib.bankName}</p>
                </div>
              </div>
            </div>

            <div className="border rounded-lg p-4">
              <div className="flex justify-between items-center">
                <div className="flex-1">
                  <p className="text-sm text-gray-500">IBAN</p>
                  <p className="font-mono text-sm">{rib.iban}</p>
                </div>
                <Button
                  onClick={() => handleCopy(rib.iban, 'IBAN')}
                  variant="ghost"
                  size="sm"
                >
                  <Copy size={16} />
                </Button>
              </div>
            </div>

            <div className="border rounded-lg p-4">
              <div className="flex justify-between items-center">
                <div className="flex-1">
                  <p className="text-sm text-gray-500">BIC</p>
                  <p className="font-mono text-sm">{rib.bic}</p>
                </div>
                <Button
                  onClick={() => handleCopy(rib.bic, 'BIC')}
                  variant="ghost"
                  size="sm"
                >
                  <Copy size={16} />
                </Button>
              </div>
            </div>

            <div className="border rounded-lg p-4">
              <div className="flex justify-between items-center">
                <div className="flex-1">
                  <p className="text-sm text-gray-500">Titulaire du compte</p>
                  <p className="font-medium">{rib.accountHolder}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 bg-green-50 border border-green-200 rounded-lg p-4">
            <p className="text-sm text-green-800">
              <strong>ℹ️ Information :</strong> Ce RIB est lié à votre compte crédit Fortuneo Immobilier.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RIBPage;